import React from 'react';
import Lozenge from '@atlaskit/lozenge';
import { Inline } from '@atlaskit/primitives';
import { useIntl } from '@atlassian/jira-intl';
import { type MenuNode, MenuNodeType } from '@atlassian/jira-software-context-menu';
import { EDIT_COVER_MENU_ID } from '../../constants';
import messages from './messages';
import type { Props, ContentProps, LabelProps } from './types';

const EditCoverLabel = ({ showNewLozenge }: LabelProps) => {
	const { formatMessage } = useIntl();

	return (
		<Inline alignBlock="center" space="space.100">
			{formatMessage(messages.editCover)}
			{showNewLozenge && <Lozenge appearance="new">{formatMessage(messages.newLozenge)}</Lozenge>}
		</Inline>
	);
};

export const useEditCoverContent = ({
	onEditCover,
	showNewLozenge = true,
}: ContentProps): MenuNode[] => [
	{
		type: MenuNodeType.Item,
		label: () => <EditCoverLabel showNewLozenge={showNewLozenge} />,
		id: EDIT_COVER_MENU_ID,
		onClick: onEditCover,
		analytics: {
			attributes: {
				selectedOption: EDIT_COVER_MENU_ID,
			},
		},
	},
];

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const useEditCover = ({ issueId }: Props) => {
	// TODO: PNDR-1889 Determine showNewLozenge based on changeboarding & audience
	const showNewLozenge = true;

	// TODO: Implement card cover popover
	// eslint-disable-next-line @typescript-eslint/no-empty-function
	const onEditCover = () => {};

	return useEditCoverContent({
		onEditCover,
		showNewLozenge,
	});
};
